<template>
	<span class="flex w-[75px] justify-between tabular-nums">
		<span>&euro;</span>
		<span>
			<slot />
		</span>
	</span>
</template>
